import { TThunkAction } from '../../types/redux';
import { getRealtors } from '../../api/realtors';
import { getAgencies } from '../../api/agencies';
import { setAgenciesItems, setAgenciesLoading, setRealtorItems, setRealtorsLoading } from '../listing';
import { ETabs } from '../../types/redux/tabs';
import { setActiveTab } from './actions';
import { getQueryString } from '../../utils/getQueryString';
import { trackPageView } from '../../utils/analytics/trackPageView';

export function setAgenciesTab(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    dispatch(setActiveTab(ETabs.Agencies));
    dispatch(setAgenciesLoading(true));

    const state = getState();
    const {
      agencies: {
        filters,
        listing: { page },
      },
      geo: { locationsMap },
    } = state;
    // oxlint-disable-next-line typescript/no-non-null-assertion
    const regionId = locationsMap[ETabs.Agencies]!.id;
    const params = { ...filters, regionId, page: 1 };

    // TODO: Вторую пустую строку заменить на реальный document title CD-100235
    window.history.pushState('', '', getQueryString(ETabs.Agencies, page, params));

    trackPageView(state);

    return getAgencies(context, params).then(response => {
      dispatch(
        setAgenciesItems({
          ...response,
          page: 1,
        }),
      );
    });
  };
}

export function setRealtorsTab(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    dispatch(setActiveTab(ETabs.Realtors));
    dispatch(setRealtorsLoading(true));

    const state = getState();
    const {
      realtors: {
        filters,
        listing: { page },
      },
      geo: { locationsMap },
    } = state;
    // oxlint-disable-next-line typescript/no-non-null-assertion
    const regionId = locationsMap[ETabs.Realtors]!.id;
    const params = { ...filters, regionId, page: 1 };

    // TODO: Вторую пустую строку заменить на реальный document title CD-100235
    window.history.pushState('', '', getQueryString(ETabs.Realtors, page, params));

    trackPageView(state);

    return getRealtors(context, params).then(response => {
      dispatch(
        setRealtorItems({
          ...response,
          page: 1,
        }),
      );
    });
  };
}
